// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-container[data-v-654ca4e7]{height:100%;width:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.player-container .player[data-v-654ca4e7]{height:100%;width:100%;padding:20px;max-height:100%!important}.player-container .player[data-v-654ca4e7] .youtube-player__video-container{height:100%}", ""]);
// Exports
module.exports = exports;
